export function formatName(
  name: string = '',
  maxLength: number = 50, //  maxLength <= 0, no truncation is applied.
  removeExtension: boolean = false,
): string {
  let baseName = name;

  if (removeExtension) {
    const lastDotIndex = name.lastIndexOf('.');
    if (lastDotIndex > 0) {
      baseName = name.substring(0, lastDotIndex);
    }
  }

  if (maxLength > 0 && baseName.length > maxLength) {
    baseName = baseName.substring(0, maxLength) + '...';
  }

  return baseName;
}
